<template>
  <v-dialog
    class="elevation-0 theme-border"
    v-model="flag"
    width="800"
    :class="isExtension ? 'ext-margin' : 'non-ext-margin'"
  >
    <v-card>
      <!-- Title bar -->
      <v-card-title
        class="py-3 px-4 text-truncate dialog-title-border dark-purple-text"
      >
        <div class="d-flex justify-center align-center" style="width: 90%">
          Advanced Filters
        </div>

        <v-spacer></v-spacer>
        <v-icon small color="#757096" @click="flag = false">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="py-8">
        <v-row>
          <!-- Members Filter (Active/Archive) -->
          <v-col md="5" cols="12">
            <div class="dark-purple-text body-2 font-weight-bold">
              Filter by Status
            </div>
            <div class="mt-2">
              <div :class="isMac ? 'edited_scrollbar' : ''">
                <v-list>
                  <div
                    v-for="list of dropdownList"
                    :key="list.text"
                    class="status-list-min-height caption anchor-hover d-flex pointer"
                    @click="$store.commit('setMembersView', list.text)"
                  >
                    <v-icon
                      small
                      color="#1cc283"
                      class="mr-3"
                      v-text="
                        getMembersView == list.text
                          ? 'mdi-checkbox-marked-circle'
                          : 'mdi-checkbox-blank-circle-outline'
                      "
                    ></v-icon>
                    <v-list-item-content
                      :class="
                        getMembersView == list.text
                          ? 'success-text font-weight-bold'
                          : ''
                      "
                      class="px-3"
                      >{{
                        list.text == "Archive" ? list.text + "d" : list.text
                      }}
                      Members</v-list-item-content
                    >
                  </div>
                </v-list>
              </div>
            </div>
          </v-col>
          <div class="border-right mx-12"></div>
          <v-col md="5" cols="12">
            <div class="dark-purple-text body-2 font-weight-bold">
              Filter by Domain
              <!-- Domain Tooltip -->
              <v-tooltip color="#DCD8F3" top right>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    color="#2a206a"
                    class="pointer"
                    x-small
                    >mdi-information-outline</v-icon
                  >
                </template>
                <span class="font-weight-bold dark-purple-text">
                  Company domain is a set of email addresses <br />
                  owned by the company e.g) xyz@company.com
                </span>
              </v-tooltip>
            </div>
            <div class="mt-2" :class="isMac ? 'edited_scrollbar' : ''">
              <v-list>
                <div
                  class="status-list-min-height caption anchor-hover d-flex pointer"
                  @click="$store.commit('setOutsiders', false)"
                >
                  <v-icon
                    small
                    color="#1cc283"
                    class="mr-3"
                    v-text="
                      !getOutsiders
                        ? 'mdi-checkbox-marked-circle'
                        : 'mdi-checkbox-blank-circle-outline'
                    "
                  ></v-icon>
                  <v-list-item-content
                    class="px-3"
                    :class="
                      !getOutsiders ? 'font-weight-bold success-text' : ''
                    "
                  >
                    All</v-list-item-content
                  >
                </div>
                <div
                  class="status-list-min-height caption anchor-hover d-flex pointer"
                  @click="$store.commit('setOutsiders', true)"
                >
                  <v-icon
                    small
                    color="#1cc283"
                    class="mr-3"
                    v-text="
                      getOutsiders
                        ? 'mdi-checkbox-marked-circle'
                        : 'mdi-checkbox-blank-circle-outline'
                    "
                  ></v-icon>
                  <v-list-item-content
                    class="px-3"
                    :class="getOutsiders ? 'font-weight-bold success-text' : ''"
                    >Outsiders</v-list-item-content
                  >
                </div>
              </v-list>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="border-top">
        <v-btn
          @click="resetFilters()"
          depressed
          small
          color="#edebf9"
          class="text-capitalize dusty-purple-bg"
        >
          <v-icon color="#2a206a" small>mdi-restore</v-icon>
          <span class="body-2 mx-1 dark-purple-text">Reset Filters</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: ["drawer"],
  data() {
    return {
      flag: false,
      dropdownList: [{ text: "All" }, { text: "Active" }, { text: "Archive" }],
    };
  },
  computed: {
    ...mapGetters([
      "getOutsiders",
      "getMembersView",
      "getReportsDate",
      "getReportsStatus",
      "getReportsView",
      "getSelectedCompany",
    ]),
  },
  watch: {
    drawer(value) {
      if (value) this.flag = true;
    },
    flag(value) {
      if (!value) this.$emit("update:drawer", false);
    },
  },
  methods: {
    resetFilters() {
      this.$store.commit("setOutsiders", false);
      this.$store.commit("setMembersView", "All");
    },
  },
};
</script>
<style scoped></style>
